<app-page headline="Warehouses">
  @if (warehousesDatasource) {
    <DataTable
      [datasource]="warehousesDatasource"
      [columns]="warehousesColumns"
      (rowClick)="handleRowClick($event)"
    >
      <div
        row-layout
        paddingLeft="md"
        ngProjectAs="data-table-header"
        justifyContent="space-between"
        alignItems="center"
        [class]="tableHeaderClassName"
      >
        <div [class]="tableHeaderLeftClassName">
          <Text role="headline-medium" color="on-background-variant">
            Warehouse Management
          </Text>
          <app-download-button
            [blobObservable]="
              warehouseService.downloadWarehouses(
                selectedDcc() || '',
                '',
                selectedWms() || ''
              )
            "
            tooltipPlacement="top"
            label="Download filtered Warehouse Data (xlsx)"
            [downloadFileName]="warehousesDownloadFileName()"
          />
        </div>

        <div [class]="tableHeaderFilterClassName">
          <Text role="headline-small"> Filter by: </Text>
          <div [class]="tableHeaderFilterGroupClassName">
            <Text color="on-primary-surface-variant">DCC</Text>
            <app-select
              [form]="filterForm"
              controlName="dcc"
              [options]="dccOptions()"
            ></app-select>
          </div>
          <div [class]="tableHeaderFilterGroupClassName">
            <Text color="on-primary-surface-variant">WMS</Text>
            <app-select
              [form]="filterForm"
              controlName="wms"
              [options]="wmsOptions()"
            ></app-select>
          </div>
        </div>
      </div>
    </DataTable>
  }
</app-page>